// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-5e7d7948]{font-weight:700;color:#f4f5f7}#text-right[data-v-5e7d7948]{margin-left:auto}", ""]);
// Exports
module.exports = exports;
